<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-graduation-cap"></i> Schools</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
              <router-link v-bind:to="{name: 'add-school' }" class="button is-info is-pulled-right">Add new</router-link>
            </div>
            <div class="column">
                <schools-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" :total="total" v-bind:items="schools" v-bind:actions="true"></schools-table>
            </div>
        </div>          
    </div>  
</template>

<script>
import SchoolRepo from '../../repos/SchoolRepo'
import lodash from 'lodash'
import SchoolsTable from "./Table";

export default {
  name: 'schools-view',
  components: {SchoolsTable},
  data() {
        return {
            repo: new SchoolRepo(this.$auth),
            schools: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
        }
  },
  created(){
    this.getSchools();
  },
  methods: {
    onSearch(q){
        this.page = 1;
        this.q = q;
        this.getSchools();
    },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getSchools();
    },
    onPageChanged(page){
        this.page = page;        
        this.getSchools();
    },
    getSchools(){
        this.repo.paginate(this.page, this.q, this.orderBy).then(response => {            
            this.schools = response.data.data;
            this.total = response.data.meta.pagination.total_pages            
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/schools/View.vue